import { useEffect, useRef } from "react";
import { useLoaderData, useNavigate, useSearchParams } from "react-router-dom";
import { useAppDispatch } from "../redux/hooks";
import { updateSessionId, updateTableNumber, updateBookingType } from "../redux/slices";
//import { Loading } from './Loading';
import { SessionCheckResponse } from "../types/player";
import ReactGA from "react-ga4";

export const ValidateLink: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionStatus = useLoaderData() as SessionCheckResponse;
  let sessionId = searchParams.get("s");
  let tableNumber = searchParams.get("t");
  const dispatch = useAppDispatch();
  const gaFired = useRef<boolean>(false);

  useEffect(() => {
    ReactGA.initialize("G-CM20T5919Y");
    ReactGA.set({ venue_code: sessionStatus?.venueCode });

    if (sessionId === null) {
      navigate(`/invalidlink?session`);
      return;
    }

    const lastUpdated = sessionStatus?.last_updated
      ? new Date(sessionStatus.last_updated).toISOString().slice(0, 19)
      : "";

    switch (sessionStatus?.status) {
      case "Started":
        if (!gaFired.current) {
          gaFired.current = true;
          ReactGA.event("RapidEntryStarted", {
            venue_code: sessionStatus?.venueCode,
            booking_type: sessionStatus?.bookingType,
          });
        }
        dispatch(updateSessionId(sessionId));
        dispatch(updateTableNumber(tableNumber));
        dispatch(updateBookingType(sessionStatus?.bookingType));
        navigate(`/nickname?s=${sessionId}&t=${tableNumber}&v=${sessionStatus?.venueCode}`);
        break;
      case "Finished":
        navigate(`/sessioncompleted?s=${sessionId}&d=${lastUpdated}`);
        break;
      case "Ended":
        navigate(`/sessioncompleted?s=${sessionId}&d=${lastUpdated}`);
        break;
      case "Pending":
        navigate(`/invalidlink?pending`);
        break;
      case "Not Found":
      case null:
      case undefined:
        navigate(`/invalidlink?undefined`);
        break;
    }
  }, [sessionStatus, navigate, sessionId, tableNumber, dispatch]);

  return <></>;
};
